import { lazy } from "react";

import BillingAndInvoiceDetail from "../../components/AdminPortalComponents/FBMManagement/BillingAndInvoice/BillingAndInvoiceDetail/BillingAndInvoiceDetail";
import OrderDetails from "../../components/AdminPortalComponents/FBMManagement/Orders/OrderDetails/OrderDetails";
import EditWarehouseDetail from "../../components/AdminPortalComponents/FBMManagement/PartnerWarehouses/EditWarehouseDetail/EditWarehouseDetail";
import OrderDetail from "../../components/AdminPortalComponents/OrderManagement/OrderDetail/OrderDetail";
import ReturnOrderDetail from "../../components/AdminPortalComponents/FBMManagement/Returns/ReturnOrderDetail/ReturnOrderDetail";
import FBMManagement from "../../views/AdminPortal/FBMManagement/FBMManagement";
import Orders from "../../views/AdminPortal/OrderManagement/Orders/Orders";
import OrderFulfillment from "../../views/AdminPortal/OrderManagement/OrderFulfillment/OrderFulfillment";
import InventoryLevelsDetail from "../../components/AdminPortalComponents/OrderManagement/OrderFulfillment/InventoryLevelsDetail/InventoryLevelsDetail";
import ShippingCarrierDetail from "../../components/AdminPortalComponents/OrderManagement/OrderFulfillment/ShippingCarrierDetail/ShippingCarrierDetail";
import PartnerPerformanceDetails from "../../components/AdminPortalComponents/FBMManagement/Performance/PartnerPerformanceDetails/PartnerPerformanceDetails";
import ProductsOverview from "../../views/AdminPortal/ProductManagement/ProductsOverview/ProductsOverview";
import CategoryAndSubCategories from "../../views/AdminPortal/ProductManagement/CategoryAndSubCategories/CategoryAndSubCategories";
import ReturnsAndRefunds from "../../views/AdminPortal/OrderManagement/ReturnsAndRefunds/ReturnsAndRefunds";
import BannersCampaigns from "../../views/AdminPortal/MarketingPromotions/BannersCampaigns/BannersCampaigns";
import AttributesManagement from "../../views/AdminPortal/ProductManagement/AttributesManagement/AttributesManagement";
import InventoryManagement from "../../views/AdminPortal/ProductManagement/InventoryManagement/InventoryManagement";
import ProductApprovalQueue from "../../views/AdminPortal/ProductManagement/ProductApprovalQueue/ProductApprovalQueue";
import ActiveCampaigns from "../../views/AdminPortal/Advertisement/ActiveCampaigns/ActiveCampaigns";
import ActiveCampaignsDetails from "../../components/AdminPortalComponents/Advertisement/ActiveCampaignsDetails/ActiveCampaignsDetails";
import SellerDetails from "../../components/AdminPortalComponents/UserManagement/Seller/SellerDetails/SellerDetails";
import SellerProductDetails from "../../components/AdminPortalComponents/UserManagement/Seller/SellerProductDetails/SellerProductDetails";
import WholeSalers from "../../views/AdminPortal/UserManagement/Wholesalers/WholeSalers";
import WholesalerDetails from "../../components/AdminPortalComponents/UserManagement/Wholesalers/WholesalerDetails/WholesalerDetails";
import WholesalerProductDetails from "../../components/AdminPortalComponents/UserManagement/Wholesalers/WholesalerProductDetails/WholesalerProductDetails";
import Sellers from "../../views/AdminPortal/UserManagement/Sellers/Sellers";
import Admins from "../../views/AdminPortal/UserManagement/Admins/Admins";
import AddNewRole from "../../components/AdminPortalComponents/UserManagement/Admins/Roles/AddNewRole/AddNewRole";
import StockMonitoring from "../../views/AdminPortal/BusinessManagement/StockMonitoring/StockMonitoring";
import OrderTransactions from "../../views/AdminPortal/BusinessManagement/OrderTransactions/OrderTransactions";
import LoyaltyAndRewards from "../../components/AdminPortalComponents/UserManagement/LoyaltyAndRewards/LoyaltyAndRewards";
import PricingFinanceAndPayment from "../../views/AdminPortal/PricingFinanceAndPayment/PricingFinanceAndPayment";
import Coupons from "../../views/AdminPortal/MarketingPromotions/Coupons/Coupons";
import CouponDetail from "../../components/AdminPortalComponents/MarketingPromotions/Coupons/PlatformGeneratedCoupons/CouponDetail/CouponDetail";
import SellerCouponDetail from "../../components/AdminPortalComponents/MarketingPromotions/Coupons/SellerGeneratedCoupons/SellerCouponDetail/SellerCouponDetail";
import Vouchers from "../../views/AdminPortal/MarketingPromotions/Vouchers/Vouchers";
import PurchaseHistory from "../../views/AdminPortal/BusinessManagement/PurchaseHistory/PurchaseHistory";
import TransactionInsights from "../../views/AdminPortal/BusinessManagement/OrderTransactions/TransactionInsights";
import RefundTransactions from "../../views/AdminPortal/Refund&DisputeManagement/RefundTransactions/RefundTransactions";
import RefundRequestList from "../../views/AdminPortal/Refund&DisputeManagement/RefundRequestList/RefundRequestList";
import RefundPolicies from "../../views/AdminPortal/Refund&DisputeManagement/RefundPolicies/RefundPolicies";
import FreeDelivery from "../../views/AdminPortal/MarketingPromotions/FreeDelivery/FreeDelivery";
import PushNotifications from "../../views/AdminPortal/MarketingPromotions/PushNotifications/PushNotifications";
import AddNewAdmin from "../../components/AdminPortalComponents/UserManagement/Admins/Admins/AddNewAdmin/AddNewAdmin";
import AddCustomPermission from "../../components/AdminPortalComponents/UserManagement/Admins/CustomPermissions/AddCustomPermission/AddCustomPermission";
import Transactions from "../../components/AdminPortalComponents/PricingFinanceAndPayments/Transactions/Transactions";
import Payouts from "../../components/AdminPortalComponents/PricingFinanceAndPayments/Payouts/Payouts";
import PaymentMethods from "../../components/AdminPortalComponents/PricingFinanceAndPayments/PaymentMethods/PaymentMethods";
import LoanManagement from "../../components/AdminPortalComponents/PricingFinanceAndPayments/LoanManagement/LoanManagement";
import ShippingAndDelivery from "../../views/AdminPortal/ShippingAndDelivery/ShippingAndDelivery";
import AddNewShippingOption from "../../components/AdminPortalComponents/ShippingAndDelivery/AddNewShippingOption/AddNewShippingOption";
import AddNewShippingCarrier from "../../components/AdminPortalComponents/ShippingAndDelivery/AddNewShippingCarrier/AddNewShippingCarrier";
import ShippingCarrier from "../../views/AdminPortal/ShippingAndDelivery/ShippingCarrier";
import DeliveryZone from "../../views/AdminPortal/ShippingAndDelivery/DeliveryZone";
import AddNewDeliveryZone from "../../components/AdminPortalComponents/ShippingAndDelivery/AddNewDeliveryZone/AddNewDeliveryZone";
import CarrierManagement from "../../views/AdminPortal/ShippingAndDelivery/CarrierManagement";
import AddCarrier from "../../components/AdminPortalComponents/ShippingAndDelivery/AddCarrier/AddCarrier";
import Notifications from "../../views/AdminPortal/SettingsAndConfigurations/Notifications/Notifications";
import TaxSettings from "../../views/AdminPortal/SettingsAndConfigurations/TaxSettings/TaxSettings";
import Currency from "../../views/AdminPortal/SettingsAndConfigurations/Currency/Currency";
import Messages from "../../views/AdminPortal/Support&Communication/Messages/Messages";
import SupportTickets from "../../views/AdminPortal/Support&Communication/SupportTickets/SupportTickets";
import FeedbackAndSuggestions from "../../views/AdminPortal/Support&Communication/Feedback&Suggestions/FeedbackAndSuggestions";
import FAQs from "../../views/AdminPortal/Support&Communication/FAQs/FAQs";
import SellerPicks from "../../views/AdminPortal/MarketingPromotions/SellerPicks/SellerPicks";
import SocialMediaMarketing from "../../views/AdminPortal/MarketingPromotions/SocialMediaMarketing/SocialMediaMarketing";
import Dashboard from "../../views/AdminPortal/Dashboard/Dashboard";
import Language from "../../views/AdminPortal/SettingsAndConfigurations/Language/Language";
import PageSetup from "../../views/AdminPortal/WebAndAppManagement/PageSetup";
import SocialMediaLinks from "../../views/AdminPortal/WebAndAppManagement/SocialMediaLinks";
import TrainingAndResources from "../../views/AdminPortal/ContentManagement/TrainingAndResources/TrainingAndResources";
import ReportsAndAnalytics from "../../views/AdminPortal/ReportsAndAnalytics/ReportsAndAnalytics";
import CustomerAndUserAnalaytics from "../../views/AdminPortal/ReportsAndAnalytics/CustomerAndUserAnalytics";

const DocumentTemplates = lazy(() => import('../../views/AdminPortal/ContentManagement/DocumentTemplates/DocumentTemplates'))
// const CustomerAndUserAnalaytics = lazy(() => import('../../views/AdminPortal/ReportsAndAnalytics/CustomerAndUserAnalytics'))
// import DocumentTemplatesCategories from "../../views/AdminPortal/ContentManagement/DocumentTemplatesCategories/DocumentTemplatesCategories";

const adminRoutes = [
    {
        path: "/dashboard",
        element: <Dashboard />,
        meta: {
            layout: 'vertical',
        }
    },
    {
        path: "/ordermanagement",
        meta: {
            layout: 'vertical',
        },
        children: [
            {
                path: "orders",
                element: <Orders />,
            },
            {
                path: "orders/detail",
                element: <OrderDetail />,
            },
            {
                path: "orderfulfillment",
                element: <OrderFulfillment />,
            },
            {
                path: "orderfulfillment/inventorydetail",
                element: <InventoryLevelsDetail />,
            },
            {
                path: "orderfulfillment/shippingdetail",
                element: <ShippingCarrierDetail />,
            },
            {
                path: "returns",
                element: <ReturnsAndRefunds />,
            },
        ]
    },
    {
        path: "/product-management",
        meta: {
            layout: 'vertical',
        },
        children: [
            {
                path: "overview",
                element: <ProductsOverview />,
            },
            {
                path: "category-and-subcategories",
                element: <CategoryAndSubCategories />,
            },
            {
                path: "attributes-management",
                element: <AttributesManagement />,
            },
            {
                path: "inventory-management",
                element: <InventoryManagement />,
            },
            {
                path: "product-approval-queue",
                element: <ProductApprovalQueue />,
            },
            // {
            //     path: "orders/detail",
            //     element: <OrderDetail />,
            // },
        ]
    },
    {
        path: "/fbm-management",
        element: <FBMManagement />,
        meta: {
            layout: 'vertical',
        }
    },
    {
        path: '/fbm-management/edit-warehouse-detail',
        element: <EditWarehouseDetail />,
        meta: {
            layout: 'vertical',
        }
    },
    {
        path: '/fbm-management/view-order-detail',
        element: <OrderDetails />,
        meta: {
            layout: 'vertical',
        }
    },
    {
        path: '/fbm-management/view-return-order-detail',
        element: <ReturnOrderDetail />,
        meta: {
            layout: 'vertical',
        }
    },
    {
        path: '/fbm-management/view-billing-and-invoicing-detail',
        element: <BillingAndInvoiceDetail />,
        meta: {
            layout: 'vertical',
        }
    },
    {
        path: '/fbm-management/view-partner-performance-detail',
        element: <PartnerPerformanceDetails />,
        meta: {
            layout: 'vertical',
        }
    },
    {
        path: "/marketing",
        meta: {
            layout: 'vertical',
        },
        children: [
            {
                path: "campaigns",
                element: <BannersCampaigns />,
            },
            {
                path: "coupons",
                element: <Coupons />,
            },
            {
                path: "coupons/platformcoupondetail",
                element: <CouponDetail />,
            },
            {
                path: "coupons/sellercoupondetail",
                element: <SellerCouponDetail />,
            },
            {
                path: "vouchers",
                element: <Vouchers />,
            },
            {
                path: "freedelivery",
                element: <FreeDelivery />,
            },
            {
                path: "pushnotifications",
                element: <PushNotifications />,
            },
            {
                path: "sellerpicks",
                element: <SellerPicks />,
            },
            {
                path: "smm",
                element: <SocialMediaMarketing />,
            },
        ]
    },
    {
        path: "/advertisement",
        meta: {
            layout: 'vertical',
        },
        children: [
            {
                path: "active-campaigns",
                element: <ActiveCampaigns />,
            },
            {
                path: "active-campaign-detail",
                element: <ActiveCampaignsDetails />,
            },
        ]
    },
    {
        path: "/user-management",
        meta: {
            layout: 'vertical',
        },
        children: [
            {
                path: "sellers",
                element: <Sellers />,
            },
            {
                path: "sellers/seller",
                element: <SellerDetails />,
            },
            {
                path: "sellers/seller/products",
                element: <SellerProductDetails />,
            },
            {
                path: "wholesalers",
                element: <WholeSalers />,
            },
            {
                path: "wholesalers/wholesaler",
                element: <WholesalerDetails />,
            },
            {
                path: "wholesalers/wholesaler/products",
                element: <WholesalerProductDetails />,
            },
            {
                path: 'admins',
                element: <Admins />
            },
            {
                path: 'admins/add-new-admin',
                element: <AddNewAdmin />
            },
            {
                path: 'admins/add-new-role',
                element: <AddNewRole />
            },
            {
                path: 'admins/add-custom-permission',
                element: <AddCustomPermission />
            },
            {
                path: 'loyalty-and-rewards',
                element: <LoyaltyAndRewards />
            },
        ]
    },
    {
        path: "/businessmanagement",
        meta: {
            layout: 'vertical',
        },
        children: [
            {
                path: "stockmonitoring",
                element: <StockMonitoring />,
            },
            {
                path: "ordertransactions",
                element: <OrderTransactions />,
            },
            {
                path: "ordertransactions/transactionInsights",
                element: <TransactionInsights />,
            },
            {
                path: "purchasehistory",
                element: <PurchaseHistory />,
            },
        ]
    },
    {
        path: "/refund-and-dispute-management",
        meta: {
            layout: 'vertical',
        },
        children: [
            {
                path: "refundtransactions",
                element: <RefundTransactions />,
            },
            {
                path: "refundrequestlist",
                element: <RefundRequestList />,
            },
            {
                path: "refundpolicyandguidlines",
                element: <RefundPolicies />,
            },
        ]
    },
    {
        path: "/support-and-communication",
        meta: {
            layout: 'vertical',
        },
        children: [
            {
                path: "messages",
                element: <Messages />,
            },
            {
                path: "support-tickets",
                element: <SupportTickets />,
            },
            {
                path: "FAQs",
                element: <FAQs />,
            },
            {
                path: "feedback-and-suggestions",
                element: <FeedbackAndSuggestions />,
            },
        ]
    },
    {
        path: "/pricing-finance-and-payment",
        meta: {
            layout: 'vertical',
        },
        children: [
            {
                path: "fee-and-commission-structure",
                element: <PricingFinanceAndPayment />,
            },
            {
                path: "transactions",
                element: <Transactions />,
            },
            {
                path: "payouts",
                element: <Payouts />,
            },
            {
                path: "payment-methods",
                element: <PaymentMethods />,
            },
            {
                path: "loan-management",
                element: <LoanManagement />,
            },
        ]
    },
    {
        path: "/shipping-and-delivery",
        meta: {
            layout: 'vertical',
        },
        children: [
            {
                path: "shipping-options",
                element: <ShippingAndDelivery />,
            },
            {
                path: "shipping-options/add-new-shipping-option",
                element: <AddNewShippingOption />,
            },
            {
                path: "shipping-carriers",
                element: <ShippingCarrier />,
            },
            {
                path: "shipping-carriers/add-new-shipping-carrier",
                element: <AddNewShippingCarrier />,
            },
            {
                path: "delivery-zones",
                element: <DeliveryZone />
            },
            {
                path: "delivery-zones/add-new-delivery-zone",
                element: <AddNewDeliveryZone />
            },
            {
                path: "carrier-management",
                element: <CarrierManagement />
            },
            {
                path: "carrier-management/add-carrier",
                element: <AddCarrier />
            },
        ]
    },
    {
        path: "/settings-and-configurations",
        meta: {
            layout: 'vertical',
        },
        children: [
            {
                path: "notifications",
                element: <Notifications />,
            },
            {
                path: "tax-settings",
                element: <TaxSettings />,
            },
            {
                path: "currency",
                element: <Currency />,
            },
            {
                path: "language",
                element: <Language />,
            },
        ]
    },
    {
        path: "/web-and-app-management",
        meta: {
            layout: 'vertical',
        },
        children: [
            {
                path: "page-setup",
                element: <PageSetup />,
            },
            {
                path: "social-media-links",
                element: <SocialMediaLinks />,
            },
        ]
    },
    {
        path: "/reports-and-analytics",
        meta: {
            layout: 'vertical',
        },
        children: [
            {
                path: "sales-reports",
                element: <ReportsAndAnalytics />,
            },
            {
                path: "customer-and-user-analytics",
                element: <CustomerAndUserAnalaytics />,
            },
        ]
    },
    {
        path: "/content-management",
        meta: {
            layout: 'vertical',
        },
        children: [
            {
                path: "training-and-resources",
                element: <TrainingAndResources />,
            },
            {
                path: "document-templates",
                element: <DocumentTemplates />,
            },
        ]
    },
];

export default adminRoutes;